import React from "react";
import { ABOUT, MEDIA } from "../data/content";

const About = () => {
  return (
    <section id="about" className="section-y" data-testid="about-section">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="relative">
            <div className="absolute -top-3 -left-3 right-3 bottom-3 border border-burgundy/40 -z-10" />
            <img
              src={MEDIA.tools}
              alt="Инструменты мастерской"
              className="w-full h-[420px] object-cover border border-burgundy/40"
              data-testid="about-image"
            />
          </div>
          <p className="mt-4 text-[11px] uppercase tracking-[0.28em] text-muted_ink font-bold">
            ✦ Мастерская «Щётка», г. Брянск ✦
          </p>
        </div>

        <div className="lg:col-span-7">
          <h2 className="font-heading text-5xl md:text-7xl text-ink heading-tight">
            Дом для уставшей
            <br />
            <span className="accent text-burgundy">обуви.</span>
          </h2>
          <p className="mt-10 lede text-ink/85">{ABOUT.intro}</p>
          <p className="mt-6 body-rich text-muted_ink">{ABOUT.body}</p>

          <div className="mt-12 grid grid-cols-3 gap-6 border-t-2 border-burgundy/80 pt-8">
            <div>
              <div className="font-heading text-5xl md:text-6xl text-burgundy">14</div>
              <div className="text-[11px] uppercase tracking-[0.24em] text-muted_ink mt-2 font-bold">лет опыта</div>
            </div>
            <div>
              <div className="font-heading text-5xl md:text-6xl text-burgundy">12k+</div>
              <div className="text-[11px] uppercase tracking-[0.24em] text-muted_ink mt-2 font-bold">пар спасено</div>
            </div>
            <div>
              <div className="font-heading text-5xl md:text-6xl text-burgundy">98%</div>
              <div className="text-[11px] uppercase tracking-[0.24em] text-muted_ink mt-2 font-bold">возвращаются</div>
            </div>
          </div>

          <p className="mt-12 accent text-burgundy text-3xl">— {ABOUT.signature}</p>
        </div>
      </div>
    </section>
  );
};

export default About;
